import ResourceList from '../../components/ResourceList';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toArray} from '../../util/idMap';
import {LoadUsersEpic} from '../../actions/users.actions';
import CircularProgress from 'material-ui/CircularProgress'


/**
 * @augments {Component<{company: any, companyId: string, loadUsers(id:string): any, loading: boolean, users: any[]}, {}>}
 */
class CompanyUsers extends Component {

  componentDidMount() {
    if (this.props.company) {
      console.log(this.props.company);
      this.props.loadUsers(this.props.company.iqEntityId);
    } else {
      this.props.loadUsers(this.props.companyId);
    }
  }

  getColumns() {
    return [
      {name: 'FirstName', label: 'First Name'},
      {name: 'LastName', label: 'Last Name'},
      {name: 'UserName', label: 'Username'},
      {name: 'Email', label: 'Email'},
    ];
  }

  render() {
    return (
      <div>
        <ResourceList columns={this.getColumns()} data={this.props.users} showCheckboxes={true}/>
        {this.props.loading? <div style={{textAlign: 'center'}}><CircularProgress/></div> : null }
      </div>
    );
  }

}

const mapStateToProps = ({usersEndpoint, authEndpoint, companiesEndpoint}, {match}) => ({
  loading: usersEndpoint.fetchInProgress,
  loadingError: usersEndpoint.fetchError,
  users: toArray(usersEndpoint.users),
  company: match.params.companyId? companiesEndpoint.companies[match.params.companyId] : null,
  companyId: authEndpoint.companyId
})

const mapDispatchToProps = (dispatch) => ({
  loadUsers: (companyId) => dispatch(LoadUsersEpic(companyId))
})
export default connect(mapStateToProps, mapDispatchToProps)(CompanyUsers);


// WEBPACK FOOTER //
// ./src/containers/Companies/CompanyUsers.js